// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  E.g. 
  @include mix.position-fix(-15px, 0 0 -15px 0);
  @include mix.respond(1280px) { @include mix.position-reset(); }
*/
.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

.display-flex {
  display: flex !important;
}

.display-block {
  display: block !important;
}

.display-inline-block {
  display: inline-block !important;
}

.display-grid {
  display: grid !important;
}

.display-inline {
  display: inline !important;
}

.display-inline-flex {
  display: inline-flex !important;
}

.display-none {
  display: none !important;
}

.direction-column {
  flex-direction: column;
}

.align-items-start {
  align-items: flex-start !important;
}
.align-items-center {
  align-items: center !important;
}
.align-items-end {
  align-items: flex-end !important;
}
.align-items-stretch {
  align-items: stretch !important;
}
.align-items-baseline {
  align-items: baseline !important;
}
.align-content-start {
  align-content: flex-start !important;
}
.align-content-center {
  align-content: center !important;
}
.align-content-end {
  align-content: flex-end !important;
}
.align-content-stretch {
  align-content: stretch !important;
}
.align-content-baseline {
  align-content: baseline !important;
}
.align-content-between {
  align-content: space-between !important;
}
.align-content-around {
  align-content: space-around !important;
}
.align-self-start {
  align-self: flex-start !important;
}
.align-self-center {
  align-self: center !important;
}
.align-self-end {
  align-self: flex-end !important;
}
.align-self-stretch {
  align-self: stretch !important;
}
.align-self-baseline {
  align-self: baseline !important;
}

.justify-items-start {
  justify-items: flex-start !important;
}
.justify-items-center {
  justify-items: center !important;
}
.justify-items-end {
  justify-items: flex-end !important;
}
.justify-items-stretch {
  justify-items: stretch !important;
}
.justify-items-baseline {
  justify-items: baseline !important;
}
.justify-content-start {
  justify-content: flex-start !important;
}
.justify-content-center {
  justify-content: center !important;
}
.justify-content-end {
  justify-content: flex-end !important;
}
.justify-content-stretch {
  justify-content: stretch !important;
}
.justify-content-baseline {
  justify-content: baseline !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-around {
  justify-content: space-around !important;
}
.justify-self-start {
  justify-content: flex-start !important;
}
.justify-self-center {
  justify-content: center !important;
}
.justify-self-end {
  justify-content: flex-end !important;
}
.justify-self-stretch {
  justify-content: stretch !important;
}
.justify-self-baseline {
  justify-content: baseline !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}
.flex-1 {
  flex: 1 !important;
}

.position-relative {
  position: "relative" !important;
}

.position-absolute {
  position: "absolute" !important;
}

.position-fixed {
  position: "fixed" !important;
}

.position-static {
  position: "static" !important;
}

.background-color--white {
  background-color: white !important;
}
.background-color--primary {
  background-color: #2f3164 !important;
}
.background-color--secondary {
  background-color: #2f3164 !important;
}
.background-color--success {
  background-color: #becdae !important;
}
.background-color--muted {
  background-color: #e6e6e6 !important;
}
.background-color--danger {
  background-color: #b3002d !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-fit {
  width: -moz-fit-content !important;
  width: fit-content !important;
}

.card-spacing-top {
  margin-top: 15px !important;
}
.card-spacing-bottom {
  margin-bottom: 15px !important;
}

.line-height-16 {
  line-height: 1.6;
}

.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.text-xs {
  font-size: 10px !important;
}
.text-sm {
  font-size: 14px !important;
}
.text-md {
  font-size: 15px !important;
}
.text-nrm {
  font-size: 16px !important;
}
.text-lg {
  font-size: 20px !important;
}
.text-normal {
  font-style: normal !important;
}
.text-italic {
  font-style: italic !important;
}
.text-normal {
  font-weight: 400 !important;
}
.text-semibold {
  font-weight: 600 !important;
}
.text-cap {
  text-transform: capitalize !important;
}
.text-upper {
  text-transform: uppercase !important;
}
.text-lower {
  text-transform: lowercase !important;
}
.text-white {
  color: #fff !important;
}
.text-black {
  color: rgba(0, 0, 0, 0.87) !important;
}
.text-link {
  color: #0000ff;
  cursor: pointer;
}
.text-primary {
  color: #2f3164 !important;
}
.text-success {
  color: hsl(109, 56%, 25%) !important;
}
.text-danger {
  color: #b3002d !important;
}
.text-muted {
  color: rgba(0, 0, 0, 0.54);
}
.text-underline {
  text-decoration: underline !important;
}
.text-underline-none {
  text-decoration: none !important;
}

.border-0 {
  border-width: 0 !important;
}
.border-none {
  border: 0px solid transparent !important;
}

.cursor-pointer {
  cursor: pointer;
}

.page-bottom-leeway {
  margin-bottom: 200px;
}

.transition-default {
  transition: 0.2s ease;
}

.overflow-hidden {
  overflow: hidden !important;
}
.overflow-visible {
  overflow: visible !important;
}
.overflow-auto {
  overflow: auto !important;
}

.box-shadow--normal {
  box-shadow: 0 0 41px -19px rgba(47, 49, 100, 0.3) !important;
}

.mat-mdc-form-field-error {
  font-size: 12px;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #000;
  color: #fff;
  padding: 8px 16px;
  z-index: 9999;
  text-decoration: none;
  font-weight: 600;
}
.skip-link:focus {
  top: 0;
}

.sidenav-container {
  height: 100%;
}

.sidenav {
  background-color: #f6f6f6;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  width: 210px;
}
.sidenav__brand {
  background-color: white !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  height: 75px;
  padding: 10px 10px;
  width: 100%;
}
.sidenav__logo {
  height: 35px;
}
@media print {
  .sidenav {
    display: none;
  }
}

::ng-deep .mat-drawer-inner-container {
  overflow: hidden !important;
}

::ng-deep mat-expansion-panel.mat-expansion-panel {
  margin-bottom: 12px !important;
}

.mat-drawer-container {
  background-color: #fafafa;
}

.img--top {
  height: 720px;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  z-index: -1;
}

.sidenav .mat-toolbar {
  background: inherit;
  position: relative;
  z-index: 10;
}

@media print {
  .mat-toolbar {
    display: none;
  }
}

@media print {
  .mat-sidenav-content {
    margin: 0 !important;
  }
}

.mat-toolbar.mat-primary {
  justify-content: flex-end;
  position: sticky;
  top: 0;
  z-index: 1;
}

.example-container {
  background: #eee;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.app-title,
.user {
  align-items: center;
  display: flex;
  font-size: 20px;
}
@media only screen and (max-width: 460px) {
  .app-title,
  .user {
    font-size: 16px;
  }
}

.scrollTagOffset {
  position: absolute;
  top: -20px;
}

.user {
  margin-left: 0;
  max-width: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  min-width: 0;
}
@media only screen and (max-width: 460px) {
  .user {
    margin-left: 20px;
    max-width: none;
    gap: 0.375rem;
  }
}
@media only screen and (max-width: 640px) {
  .user {
    max-width: none;
    gap: 0.25rem;
  }
}
@media only screen and (max-width: 426px) {
  .user {
    max-width: none;
    gap: 0.25rem;
  }
}

.user-icon {
  margin-right: 5px;
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
@media only screen and (max-width: 640px) {
  .user-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
}
@media only screen and (max-width: 426px) {
  .user-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}

.user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
@media (min-width: 641px) {
  .user-name {
    overflow: visible;
    text-overflow: clip;
  }
}

.fill-remaining-space {
  flex: 1 1 auto;
}

.mat-mdc-list-item {
  font-size: 15px;
  margin-left: 8px;
}

.mdc-list {
  padding: 0;
  padding-top: 4px;
}

.wrapText {
  white-space: normal;
}

.mat-mdc-list-base[dense] .mat-mdc-list-item {
  font-size: 14px;
  height: 40px;
}

.contain-list {
  margin-bottom: 200px;
}

.main-content {
  margin: 0 auto;
  max-width: 1920px;
  padding: 16px 35px;
}
@media (min-width: 768px) {
  .main-content {
    min-width: 550px;
  }
}
@media only screen and (max-width: 1600px) {
  .main-content {
    padding: 16px 75px;
  }
}
@media (max-width: 767.98px) {
  .main-content {
    padding: 12px 16px;
    margin: 0;
  }
}
@media (max-width: 360px) {
  .main-content {
    padding: 8px 15px;
    margin: 0;
  }
}
@media (max-width: 320px) {
  .main-content {
    padding: 8px 10px;
    margin: 0;
  }
}
@media (max-width: 280px) {
  .main-content {
    padding: 6px 8px;
  }
}

.content {
  min-height: 100vh;
}

mat-expansion-panel.mat-expansion-panel {
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 0px !important;
}
mat-expansion-panel.mat-expansion-panel:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
mat-expansion-panel.mat-expansion-panel mat-expansion-panel-header.mat-expansion-panel-header {
  background-color: #f6f6f6;
  border-radius: 0px !important;
}

mat-nav-list.mat-mdc-nav-list {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
mat-nav-list.mat-mdc-nav-list::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
mat-nav-list.mat-mdc-nav-list::-webkit-scrollbar-track {
  background: rgb(219.3, 219.3, 219.3);
}
mat-nav-list.mat-mdc-nav-list::-webkit-scrollbar-thumb {
  background-color: rgb(158.1, 158.1, 158.1);
}
mat-nav-list.mat-mdc-nav-list .mat-mdc-list-item {
  margin-bottom: 12px;
}
mat-nav-list.mat-mdc-nav-list .mat-mdc-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
mat-nav-list.mat-mdc-nav-list .mat-mdc-list-item:first-of-type {
  margin-top: 12px;
}

.nav--top {
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 0 16px -6px rgba(0, 0, 0, 0.1);
  height: 75px;
  margin-bottom: 25px;
  padding-bottom: 12px;
  padding-top: 12px;
  position: relative;
  z-index: 10;
}
.nav__notifications {
  margin-left: 25px;
}

.route--active {
  border-left: 4px solid #2f3164;
}
.route__indicator--active {
  border-left: 4px solid #2f3164;
  height: 40px;
  padding-right: 10px;
  position: absolute;
  left: 2px;
}

.user__options {
  display: flex;
  align-items: center;
  max-width: none;
  min-width: 0;
}
@media only screen and (max-width: 640px) {
  .user__options {
    max-width: 200px;
    overflow: hidden;
  }
  .user__options .user {
    max-width: 160px;
  }
  .user__options .user .user-name {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media only screen and (max-width: 426px) {
  .user__options {
    max-width: 150px;
  }
  .user__options .user {
    max-width: 120px;
    gap: 0.125rem;
  }
  .user__options .user .user-name {
    max-width: 80px;
    font-size: 14px;
  }
}
@media (max-width: 640px) {
  .user__options.user__options--desktop {
    display: none !important;
  }
}
.user__options.user__options--mobile {
  display: none;
}
@media (max-width: 640px) {
  .user__options.user__options--mobile {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
}
.user__options .mat-mdc-icon-button {
  flex-shrink: 0;
  margin-left: 0.25rem;
  margin-right: 0.5rem;
  width: 40px;
  height: 40px;
  padding: 8px;
}
@media only screen and (max-width: 640px) {
  .user__options .mat-mdc-icon-button {
    width: 36px;
    height: 36px;
    padding: 6px;
    margin-left: 0.125rem;
    margin-right: 0.375rem;
  }
}
@media only screen and (max-width: 426px) {
  .user__options .mat-mdc-icon-button {
    width: 32px;
    height: 32px;
    padding: 4px;
    margin-left: 0;
    margin-right: 0.25rem;
  }
}
.user__options--sidenav {
  display: none;
}
@media only screen and (max-width: 460px) {
  .user__options--sidenav {
    bottom: 0;
    display: inline;
    left: 0;
    position: absolute;
    right: 0;
    max-width: none;
    overflow: visible;
  }
}

@media (max-width: 640px) {
  .nav__left {
    display: none !important;
  }
}

.mobile-user-button {
  width: 44px !important;
  height: 44px !important;
  min-width: 44px;
  min-height: 44px;
}
.mobile-user-button .mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.mobile-user-button:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.mobile-user-menu .mat-mdc-menu-panel {
  min-width: 320px;
  max-width: 400px;
}
@media (max-width: 640px) {
  .mobile-user-menu .mat-mdc-menu-panel {
    min-width: 300px;
    max-width: min(400px, 100vw - 40px);
  }
}
@media (max-width: 340px) {
  .mobile-user-menu .mat-mdc-menu-panel {
    min-width: calc(100vw - 20px);
    max-width: calc(100vw - 20px);
    left: 10px !important;
    right: 10px !important;
  }
}
@media (max-width: 320px) {
  .mobile-user-menu .mat-mdc-menu-panel {
    min-width: calc(100vw - 16px);
    max-width: calc(100vw - 16px);
    left: 8px !important;
    right: 8px !important;
  }
}
.mobile-user-menu .mobile-user-info {
  display: flex !important;
  align-items: center;
  padding: 16px !important;
  cursor: default !important;
}
.mobile-user-menu .mobile-user-info:hover {
  background-color: transparent !important;
}
.mobile-user-menu .mobile-user-info .mobile-user-avatar {
  font-size: 40px;
  width: 40px;
  height: 40px;
  margin-right: 12px;
  color: #1976d2;
}
.mobile-user-menu .mobile-user-info .mobile-user-details {
  flex: 1;
  min-width: 0;
}
.mobile-user-menu .mobile-user-info .mobile-user-details .mobile-user-name {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
}
.mobile-user-menu .mobile-user-info .mobile-user-details .mobile-user-role {
  font-size: 14px;
  color: #666;
}
.mobile-user-menu .mat-mdc-menu-item {
  min-height: 48px;
  padding: 12px 16px;
}
.mobile-user-menu .mat-mdc-menu-item .mat-icon {
  margin-right: 12px;
  color: #1976d2;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.mobile-user-menu .mat-mdc-menu-item span {
  font-size: 16px;
  font-weight: 500;
}
.mobile-user-menu .mat-mdc-menu-item:hover {
  background-color: rgba(25, 118, 210, 0.04);
}
.mobile-user-menu .mat-mdc-menu-item:focus {
  background-color: rgba(25, 118, 210, 0.08);
  outline: none;
}
.mobile-user-menu .mat-divider {
  margin: 8px 0;
}
.mobile-user-menu .mobile-selectors {
  padding: 8px 0;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item {
  display: flex !important;
  align-items: flex-start !important;
  padding: 12px 16px !important;
  cursor: default !important;
  min-height: auto !important;
  background: transparent !important;
  width: 100% !important;
  text-align: left !important;
  border: none !important;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item:focus {
  background-color: rgba(25, 118, 210, 0.08) !important;
  outline: 2px solid #1976d2;
  outline-offset: -2px;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-icon {
  margin-right: 12px;
  margin-top: 12px;
  color: #1976d2;
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content {
  flex: 1;
  min-width: 0;
  width: 100%;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .selector-label {
  font-size: 12px;
  color: #333333;
  margin-bottom: 4px;
  font-weight: 500;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field {
  width: 100%;
  margin: 0;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field .mat-mdc-form-field-wrapper {
  padding-bottom: 0;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field .mat-mdc-form-field-flex {
  min-height: 44px;
  background: #f5f5f5;
  border-radius: 4px;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field .mat-mdc-select {
  font-size: 14px;
  width: 100%;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field .mat-mdc-select .mat-mdc-select-trigger {
  min-height: 44px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field .mat-mdc-select .mat-mdc-select-value {
  color: #333;
  font-weight: 500;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field .mat-mdc-select .mat-mdc-select-arrow {
  color: #1976d2;
}
.mobile-user-menu .mobile-selectors .mobile-selector-item .selector-content .mobile-form-field .mat-mdc-select:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.version {
  bottom: 1vh;
  left: 1vh;
  position: absolute;
}

.help {
  bottom: 1vh;
  position: absolute;
  width: inherit;
  background-color: #f6f6f6;
}

.help-list {
  right: 2vh;
  position: relative;
  width: inherit;
}

.bottom-buttons {
  bottom: 4vh;
  left: 0;
  position: absolute;
  right: 0;
}
.bottom-buttons button[mat-raised-button] {
  background-color: rgb(228.15, 228.15, 228.15);
  border-radius: 0;
  box-shadow: none;
  padding: 7px;
  width: 100%;
}
.bottom-buttons button[mat-raised-button]:not(:last-of-type) {
  margin-bottom: 15px;
}

.sticky-note__icon {
  color: #f5d68e;
}

@media print {
  .bg-img {
    display: none;
  }
}
.hamburger-icon {
  height: 20px;
  width: auto;
}
.hamburger-icon .arrow {
  transition: 0.3s ease;
  transform-origin: center;
}
.hamburger-icon--closed .arrow {
  transform: rotate(180deg) translate(40px, 2px);
}

.administrativeUnit-selector {
  margin-top: 20px;
  margin-right: 20px;
  min-width: 300px;
}
@media (max-width: 360px) {
  .administrativeUnit-selector {
    min-width: auto;
    margin-right: 10px;
    margin-top: 10px;
    width: 100%;
    max-width: 280px;
  }
}
@media (max-width: 320px) {
  .administrativeUnit-selector {
    min-width: auto;
    margin-right: 8px;
    margin-top: 8px;
    width: 100%;
    max-width: 260px;
  }
}

.schoolyear-selector {
  margin-top: 20px;
  margin-right: 20px;
  min-width: 200px;
}
@media (max-width: 360px) {
  .schoolyear-selector {
    min-width: auto;
    margin-right: 10px;
    margin-top: 10px;
    width: 100%;
    max-width: 140px;
  }
}
@media (max-width: 320px) {
  .schoolyear-selector {
    min-width: auto;
    margin-right: 8px;
    margin-top: 8px;
    width: 100%;
    max-width: 120px;
  }
}

.nav__container {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  min-width: 0;
}
.nav__left div {
  display: flex;
  min-width: 0;
}
.nav__right {
  min-width: 0;
  flex-shrink: 1;
}
.nav__input {
  margin-right: 1.25em;
  margin-top: 1.25em;
  min-width: 0;
}
.nav__input--year {
  min-width: 150px;
}
@media only screen and (max-width: 640px) {
  .nav__input--year {
    min-width: 120px;
  }
}
@media (max-width: 360px) {
  .nav__input--year {
    min-width: auto;
    width: 100%;
    max-width: 140px;
    margin-right: 0.5em;
    margin-top: 0.5em;
  }
}
@media (max-width: 320px) {
  .nav__input--year {
    min-width: auto;
    width: 100%;
    max-width: 120px;
    margin-right: 0.25em;
    margin-top: 0.25em;
  }
}
.nav__input--administrativeUnit {
  width: 360px;
}
@media only screen and (max-width: 1150px) {
  .nav__input--administrativeUnit {
    width: unset;
    min-width: 200px;
  }
}
@media only screen and (max-width: 640px) {
  .nav__input--administrativeUnit {
    min-width: 150px;
  }
}
@media (max-width: 360px) {
  .nav__input--administrativeUnit {
    min-width: auto;
    width: 100%;
    max-width: 200px;
    margin-right: 0.5em;
    margin-top: 0.5em;
  }
}
@media (max-width: 320px) {
  .nav__input--administrativeUnit {
    min-width: auto;
    width: 100%;
    max-width: 170px;
    margin-right: 0.25em;
    margin-top: 0.25em;
  }
}

.mat-accordion:focus-within .mat-expansion-panel-header:focus-within {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  background-color: #FFFFFF;
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.mat-expansion-panel-header-title {
  outline: none;
}

.mat-mdc-list-item:focus {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  background-color: #FFFFFF;
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

::ng-deep #schoolYearSelector .mdc-text-field,
::ng-deep #districtSelector .mdc-text-field,
::ng-deep #search .mdc-text-field {
  background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/abstracts/_mixins.scss","webpack://./node_modules/@angular/material/core/_core.scss","webpack://./src/app/nav/nav.component.scss","webpack://./src/styles/abstracts/_utilities.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAyBE;;;;CAAA;ACmBI;EACE,yJAAA;ACtCR;;ADqCM;EACE,0JAAA;AClCR;;ADiCM;EACE,0JAAA;AC9BR;;AD6BM;EACE,0JAAA;AC1BR;;ADyBM;EACE,2JAAA;ACtBR;;ADqBM;EACE,2JAAA;AClBR;;ADiBM;EACE,4JAAA;ACdR;;ADaM;EACE,4JAAA;ACVR;;ADSM;EACE,4JAAA;ACNR;;ADKM;EACE,4JAAA;ACFR;;ADCM;EACE,8JAAA;ACER;;ADHM;EACE,8JAAA;ACMR;;ADPM;EACE,8JAAA;ACUR;;ADXM;EACE,8JAAA;ACcR;;ADfM;EACE,8JAAA;ACkBR;;ADnBM;EACE,8JAAA;ACsBR;;ADvBM;EACE,+JAAA;AC0BR;;AD3BM;EACE,+JAAA;AC8BR;;AD/BM;EACE,+JAAA;ACkCR;;ADnCM;EACE,+JAAA;ACsCR;;ADvCM;EACE,gKAAA;AC0CR;;AD3CM;EACE,gKAAA;AC8CR;;AD/CM;EACE,gKAAA;ACkDR;;ADnDM;EACE,gKAAA;ACsDR;;ADvDM;EACE,gKAAA;AC0DR;;ADvFE;EACE,6BAAA;AC0FJ;;ADnFI;EACE,yFAAA;EACA,uEAAA;ACsFN;;AFpGI;EGDE,wBAAA;ADyGN;;AFxGI;EGDE,yBAAA;AD6GN;;AF5GI;EGDE,gCAAA;ADiHN;;AFhHI;EGDE,wBAAA;ADqHN;;AFpHI;EGDE,0BAAA;ADyHN;;AFxHI;EGDE,+BAAA;AD6HN;;AF5HI;EGDE,wBAAA;ADiIN;;AFhII;EGMA,sBAAA;AD8HJ;;AFpII;EGaE,kCAAA;AD2HN;AFxII;EGgBE,8BAAA;AD2HN;AF3II;EGmBE,gCAAA;AD2HN;AF9II;EGsBE,+BAAA;AD2HN;AFjJI;EGyBE,gCAAA;AD2HN;AFpJI;EG8BE,oCAAA;ADyHN;AFvJI;EGiCE,gCAAA;ADyHN;AF1JI;EGoCE,kCAAA;ADyHN;AF7JI;EGuCE,iCAAA;ADyHN;AFhKI;EG0CE,kCAAA;ADyHN;AFnKI;EG6CE,uCAAA;ADyHN;AFtKI;EGgDE,sCAAA;ADyHN;AFzKI;EGqDE,iCAAA;ADuHN;AF5KI;EGwDE,6BAAA;ADuHN;AF/KI;EG2DE,+BAAA;ADuHN;AFlLI;EG8DE,8BAAA;ADuHN;AFrLI;EGiEE,+BAAA;ADuHN;;AFxLI;EGyEE,oCAAA;ADmHN;AF5LI;EG4EE,gCAAA;ADmHN;AF/LI;EG+EE,kCAAA;ADmHN;AFlMI;EGkFE,iCAAA;ADmHN;AFrMI;EGqFE,kCAAA;ADmHN;AFxMI;EG0FE,sCAAA;ADiHN;AF3MI;EG6FE,kCAAA;ADiHN;AF9MI;EGgGE,oCAAA;ADiHN;AFjNI;EGmGE,mCAAA;ADiHN;AFpNI;EGsGE,oCAAA;ADiHN;AFvNI;EGyGE,yCAAA;ADiHN;AF1NI;EG4GE,wCAAA;ADiHN;AF7NI;EGiHE,sCAAA;AD+GN;AFhOI;EGoHE,kCAAA;AD+GN;AFnOI;EGuHE,oCAAA;AD+GN;AFtOI;EG0HE,mCAAA;AD+GN;AFzOI;EG6HE,oCAAA;AD+GN;;AF5OI;EGoIA,0BAAA;AD4GJ;AFhPI;EGwIA,kBAAA;AD2GJ;;AFnPI;EGgJE,+BAAA;ADuGN;;AFvPI;EGgJE,+BAAA;AD2GN;;AF3PI;EGgJE,4BAAA;AD+GN;;AF/PI;EGgJE,6BAAA;ADmHN;;AFxQI;EG6JE,kCAAA;AD+GN;AF5QI;EGiKE,oCAAA;AD8GN;AF/QI;EGqKE,oCAAA;AD6GN;AFlRI;EG0KE,oCAAA;AD2GN;AFrRI;EG8KE,oCAAA;AD0GN;AFxRI;EGkLE,oCAAA;ADyGN;;AFtRI;EG4LE,qBAAA;AD8FN;;AF1RI;EG4LE,qBAAA;ADkGN;;AF9RI;EG4LE,qBAAA;ADsGN;;AFlSI;EG4LE,sBAAA;AD0GN;;AFtSI;EG4LE,kCAAA;EAAA,6BAAA;AD8GN;;AF1SI;EGoME,2BAAA;AD0GN;AF9SI;EGwME,8BAAA;ADyGN;;AFjTI;EG+MA,gBAAA;ADsGJ;;AFrTI;EGwNE,2BAAA;ADiGN;AFzTI;EGwNE,6BAAA;ADoGN;AF5TI;EGwNE,4BAAA;ADuGN;AF/TI;EGqOE,0BAAA;AD6FN;AFlUI;EGqOE,0BAAA;ADgGN;AFrUI;EGqOE,0BAAA;ADmGN;AFxUI;EGqOE,0BAAA;ADsGN;AF3UI;EGqOE,0BAAA;ADyGN;AF9UI;EG4OE,6BAAA;ADqGN;AFjVI;EG4OE,6BAAA;ADwGN;AFpVI;EGsPE,2BAAA;ADiGN;AFvVI;EGsPE,2BAAA;ADoGN;AF1VI;EGiQE,qCAAA;AD4FN;AF7VI;EGiQE,oCAAA;AD+FN;AFhWI;EGiQE,oCAAA;ADkGN;AFnWI;EGsQA,sBAAA;ADgGJ;AFtWI;EGyQA,qCAAA;ADgGJ;AFzWI;EG4QA,cAAA;EACA,eAAA;ADgGJ;AF7WI;EGgRA,yBAAA;ADgGJ;AFhXI;EGmRA,oCAAA;ADgGJ;AFnXI;EGsRA,yBAAA;ADgGJ;AFtXI;EGyRA,0BAAA;ADgGJ;AFzXI;EG6RA,qCAAA;AD+FJ;AF5XI;EGgSE,gCAAA;AD+FN;;AF/XI;EGwSA,0BAAA;AD2FJ;AFnYI;EG4SA,wCAAA;AD0FJ;;AFtYI;EGmTA,eAAA;ADuFJ;;AF1YI;EG2TE,oBAAA;ADmFN;;AF9YI;EGkUA,qBAAA;ADgFJ;;AFlZI;EG0UE,2BAAA;AD4EN;AFtZI;EG0UE,4BAAA;AD+EN;AFzZI;EG0UE,yBAAA;ADkFN;;AFjaI;EGsVA,4DAAA;AD+EJ;;AC1EA;EACE,eAAA;AD6EF;;AAzaA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AA4aF;AA1aE;EACE,MAAA;AA4aJ;;AAxaA;EACE,YAAA;AA2aF;;AAxaA;EACE,yBAAA;EACA,2CAAA;EACA,YEfe;AF0bjB;AFvcI;EE+BA,kCAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AA2aJ;AF9cI;EEuCA,YAAA;AA0aJ;AAvaE;EAjBF;IAkBI,aAAA;EA0aF;AACF;;AAvaA;EACE,2BAAA;AA0aF;;AAxaA;EACE,8BAAA;AA2aF;;AAxaA;EACE,yBAAA;AA2aF;;AF7dI;EEuDA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;AA0aJ;;AAtaA;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;AAyaF;;AAraE;EADF;IAEI,aAAA;EAyaF;AACF;;AAraE;EADF;IAEI,oBAAA;EAyaF;AACF;;AAtaA;EACE,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAyaF;;AAtaA;EACE,gBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AAyaF;;AAtaA;;EAEE,mBAAA;EACA,aAAA;EACA,eAAA;AAyaF;AFpgBI;EEuFJ;;IAOI,eAAA;EA2aF;AACF;;AAxaA;EACE,kBAAA;EACA,UAAA;AA2aF;;AAxaA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AA2aF;AFzhBI;EEuGJ;IAUI,iBAAA;IACA,eAAA;IACA,aAAA;EA4aF;AACF;AFhiBI;EEuGJ;IAiBI,eAAA;IACA,YAAA;EA4aF;AACF;AFtiBI;EEuGJ;IAuBI,eAAA;IACA,YAAA;EA4aF;AACF;;AAzaA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA4aF;AFpjBI;EEmIJ;IAQI,eAAA;IACA,WAAA;IACA,YAAA;EA6aF;AACF;AF3jBI;EEmIJ;IAcI,eAAA;IACA,WAAA;IACA,YAAA;EA8aF;AACF;;AA3aA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA8aF;AA3aE;EAPF;IAQI,iBAAA;IACA,mBAAA;EA8aF;AACF;;AA3aA;EACE,cAAA;AA8aF;;AA3aA;EACE,eAAA;EACA,gBAAA;AA8aF;;AA3aA;EACE,UAAA;EACA,gBAAA;AA8aF;;AA3aA;EACE,mBAAA;AA8aF;;AA3aA;EACE,eAAA;EACA,YAAA;AA8aF;;AA3aA;EAEE,oBAAA;AA6aF;;AA1aA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AA6aF;AAzaE;EAPF;IAQI,gBAAA;EA4aF;AACF;AFrnBI;EEgMJ;IAYI,kBAAA;EA6aF;AACF;AA1aE;EAhBF;IAiBI,kBAAA;IACA,SAAA;EA6aF;AACF;AA1aE;EAtBF;IAuBI,iBAAA;IACA,SAAA;EA6aF;AACF;AA1aE;EA5BF;IA6BI,iBAAA;IACA,SAAA;EA6aF;AACF;AA1aE;EAlCF;IAmCI,gBAAA;EA6aF;AACF;;AA1aA;EACE,iBAAA;AA6aF;;AA1aA;EACE,qCE9OqB;EF+OrB,6BAAA;AA6aF;AA3aE;EACE,qCElPmB;AF+pBvB;AA1aE;EACE,yBEvPa;EFwPb,6BAAA;AA4aJ;;AAxaA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;AA2aF;ACnVE;EACE,WAAA;EACA,YAAA;ADqVJ;AClVE;EACE,oCAAA;ADoVJ;ACjVE;EACE,0CAAA;ADmVJ;AAjbE;EACE,mBAAA;AAmbJ;AAlbI;EACE,qCErQiB;AFyrBvB;AAlbI;EACE,gBAAA;AAobN;;AFtsBI;EEyRA,sBAAA;EACA,4CAAA;EACA,4CAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAibJ;AFvtBI;EE0SA,iBAAA;AAgbJ;;AFrtBI;EE2SA,8BAAA;AA8aJ;AFztBI;EEgTE,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AA4aN;;AFruBI;EEgUA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAyaJ;AF3tBI;EAjBA;IEuUE,gBAAA;IACA,gBAAA;EAyaJ;EAvaI;IACE,gBAAA;EAyaN;EAvaM;IACE,gBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EAyaR;AACF;AF1uBI;EAjBA;IEwVE,gBAAA;EAuaJ;EAraI;IACE,gBAAA;IACA,aAAA;EAuaN;EAraM;IACE,eAAA;IACA,eAAA;EAuaR;AACF;AAjaM;EADF;IAEI,wBAAA;EAoaN;AACF;AAhaI;EACE,aAAA;AAkaN;AAhaM;EAHF;IAII,wBAAA;IACA,mBAAA;IACA,uBAAA;EAmaN;AACF;AA/ZI;EACE,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAiaN;AF9wBI;EEuWA;IASI,WAAA;IACA,YAAA;IACA,YAAA;IACA,qBAAA;IACA,sBAAA;EAkaN;AACF;AFvxBI;EEuWA;IAiBI,WAAA;IACA,YAAA;IACA,YAAA;IACA,cAAA;IACA,qBAAA;EAmaN;AACF;AF5yBI;EE6YE,aAAA;AAkaN;AFnyBI;EAZA;IEgZI,SAAA;IACA,eAAA;IACA,OAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,iBAAA;EAmaN;AACF;;AA1ZE;EADF;IAEI,wBAAA;EA8ZF;AACF;;AA1ZA;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA6ZF;AA3ZE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA6ZJ;AA1ZE;EACE,0BAAA;EACA,mBAAA;AA4ZJ;;AAtZE;EACE,gBAAA;EACA,gBAAA;AAyZJ;AAvZI;EAJF;IAKI,gBAAA;IACA,mCAAA;EA0ZJ;AACF;AAxZI;EATF;IAUI,6BAAA;IACA,6BAAA;IACA,qBAAA;IACA,sBAAA;EA2ZJ;AACF;AAzZI;EAhBF;IAiBI,6BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;EA4ZJ;AACF;AAzZE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0BAAA;AA2ZJ;AAzZI;EACE,wCAAA;AA2ZN;AAxZI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA0ZN;AAvZI;EACE,OAAA;EACA,YAAA;AAyZN;AAvZM;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAyZR;AAtZM;EACE,eAAA;EACA,WAAA;AAwZR;AAnZE;EACE,gBAAA;EACA,kBAAA;AAqZJ;AAnZI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAqZN;AAlZI;EACE,eAAA;EACA,gBAAA;AAoZN;AAjZI;EACE,0CAAA;AAmZN;AAhZI;EACE,0CAAA;EACA,aAAA;AAkZN;AA9YE;EACE,aAAA;AAgZJ;AA5YE;EACE,cAAA;AA8YJ;AA5YI;EACE,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,kCAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AA8YN;AA5YM;EACE,qDAAA;AA8YR;AA3YM;EACE,qDAAA;EACA,0BAAA;EACA,oBAAA;AA6YR;AA1YM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA4YR;AAzYM;EACE,OAAA;EACA,YAAA;EACA,WAAA;AA2YR;AAzYQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA2YV;AAxYQ;EACE,WAAA;EACA,SAAA;AA0YV;AAxYU;EACE,iBAAA;AA0YZ;AAvYU;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAyYZ;AAtYU;EACE,eAAA;EACA,WAAA;AAwYZ;AAtYY;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAwYd;AArYY;EACE,WAAA;EACA,gBAAA;AAuYd;AApYY;EACE,cAAA;AAsYd;AAnYY;EACE,0BAAA;EACA,mBAAA;AAqYd;;AA5XA;EACE,WAAA;EACA,SAAA;EACA,kBAAA;AA+XF;;AA5XA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AA+XF;;AA7XA;EACE,UAAA;EACA,kBAAA;EACA,cAAA;AAgYF;;AA7XA;EACE,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;AAgYF;AA9XE;EACE,6CAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAgYJ;AA9XI;EACE,mBAAA;AAgYN;;AFzhCI;EEgqBA,cAAA;AA6XJ;;AAzXA;EACE;IACE,aAAA;EA4XF;AACF;AAzXA;EACE,YAAA;EACA,WAAA;AA2XF;AAzXE;EACE,qBAAA;EACA,wBAAA;AA2XJ;AAvXI;EACE,8CAAA;AAyXN;;AApXA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAuXF;AApXE;EANF;IAOI,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAuXF;AACF;AArXE;EAdF;IAeI,eAAA;IACA,iBAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;EAwXF;AACF;;AArXA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAwXF;AArXE;EANF;IAOI,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAwXF;AACF;AAtXE;EAdF;IAeI,eAAA;IACA,iBAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;EAyXF;AACF;;AF9lCI;EE0uBA,mBAAA;EACA,aAAA;EACA,OAAA;EACA,yBAAA;EACA,YAAA;AAwXJ;AApXI;EACE,aAAA;EACA,YAAA;AAsXN;AF1mCI;EEyvBA,YAAA;EACA,cAAA;AAoXJ;AF9mCI;EE8vBA,oBAAA;EACA,kBAAA;EACA,YAAA;AAmXJ;AF9mCI;EE8vBE,gBAAA;AAmXN;AFrmCI;EAZA;IEiwBI,gBAAA;EAoXN;AACF;AAjXM;EFrwBF;IEswBI,eAAA;IACA,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;EAoXN;AACF;AAlXM;EF7wBF;IE8wBI,eAAA;IACA,WAAA;IACA,gBAAA;IACA,oBAAA;IACA,kBAAA;EAqXN;AACF;AFxoCI;EEuxBE,YAAA;AAoXN;AF/nCI;EAZA;IE0xBI,YAAA;IACA,gBAAA;EAqXN;AACF;AFroCI;EAZA;IE+xBI,gBAAA;EAsXN;AACF;AAnXM;EFnyBF;IEoyBI,eAAA;IACA,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;EAsXN;AACF;AApXM;EF3yBF;IE4yBI,eAAA;IACA,WAAA;IACA,gBAAA;IACA,oBAAA;IACA,kBAAA;EAuXN;AACF;;AAlXA;EACE,sCAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;AAqXF;;AAlXA;EACE,aAAA;AAqXF;;AAlXA;EACE,sCAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;AAqXF;;AAlXA;;;EAGE,wCAAA;AAqXF","sourcesContent":["// BEM Mixins\r\n@mixin e($element) {\r\n    &__#{$element} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin m($modifier) {\r\n    &--#{$modifier} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin c($child) {\r\n    &-#{$child} {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Media Query Mixin\r\n  @mixin respond($respond) {\r\n    @media only screen and (max-width: #{$respond}) {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Position fixing (generally used for forms)\r\n  /*\r\n    E.g. \r\n    @include mix.position-fix(-15px, 0 0 -15px 0);\r\n    @include mix.respond(1280px) { @include mix.position-reset(); }\r\n  */\r\n  @mixin position-fix($top, $margin: 0 0 0 0) {\r\n    margin: $margin;\r\n    position: relative;\r\n    top: $top;\r\n  }\r\n  \r\n  @mixin position-reset() {\r\n    margin: 0;\r\n    position: static;\r\n    top: 0;\r\n  }","@use './m3-app';\n@use './tokens/token-utils';\n@use './style/elevation';\n\n$fallbacks: m3-app.get-tokens();\n\n/// @deprecated This mixin is a no-op and is going to be removed in v21.\n@mixin core() {}\n\n// Emits the mat-app-background CSS class. This predefined class sets the\n// background color and text color of an element.\n@mixin app-background() {\n  // TODO: Move ripple styles to be dynamically loaded instead of in core.\n  // This variable is used as a fallback for the ripple element's\n  // background color. However, if it isn't defined anywhere, then MSS\n  // complains in its verification stage.\n  html {\n    --mat-sys-on-surface: initial;\n  }\n\n  // Wrapper element that provides the theme background when the\n  // user's content isn't inside of a `mat-sidenav-container`.\n  @at-root {\n    // Note: we need to emit fallback values here to avoid errors in internal builds.\n    .mat-app-background {\n      background-color: token-utils.slot(app-background-color, $fallbacks, transparent);\n      color: token-utils.slot(app-text-color, $fallbacks, inherit);\n    }\n  }\n}\n\n// Emits CSS classes for applying elevation. These classes follow the pattern\n// mat-elevation-z#, where # is the elevation number you want, from 0 to 24.\n// These predefined classes use the CSS box-shadow settings defined by the\n// Material Design specification.\n@mixin elevation-classes() {\n  @at-root {\n    // Provides external CSS classes for each elevation value. Each CSS class is formatted as\n    // `mat-elevation-z$z-value` where `$z-value` corresponds to the z-space to which the element\n    // is elevated.\n    @for $z-value from 0 through 24 {\n      $selector: elevation.$prefix + $z-value;\n      // We need the `mat-mdc-elevation-specific`, because some MDC mixins\n      // come with elevation baked in and we don't have a way of removing it.\n      .#{$selector}, .mat-mdc-elevation-specific.#{$selector} {\n        box-shadow: token-utils.slot('app-elevation-shadow-level-#{$z-value}', $fallbacks, none);\n      }\n    }\n  }\n}\n","@use \"sass:map\";\r\n\r\n@use \"./src/styles/abstracts/mixins\" as mix;\r\n@use \"./src/styles/abstracts/utilities\" as util;\r\n@use \"./src/styles/abstracts/variables\" as var;\r\n@use \"./src/styles/theme/theme-variables\" as theme;\r\n\r\n.skip-link {\r\n  position: absolute;\r\n  top: -40px;\r\n  left: 0;\r\n  background: #000;\r\n  color: #fff;\r\n  padding: 8px 16px;\r\n  z-index: 9999;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n\r\n  &:focus {\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.sidenav-container {\r\n  height: 100%;\r\n}\r\n\r\n.sidenav {\r\n  background-color: #f6f6f6;\r\n  border-right: 1px solid rgba(0, 0, 0, 0.06);\r\n  width: var.$side-nav-width;\r\n\r\n  @include mix.e(brand) {\r\n    background-color: white !important;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\r\n    height: 75px;\r\n    padding: 10px 10px;\r\n    width: 100%;\r\n  }\r\n\r\n  @include mix.e(logo) {\r\n    height: 35px;\r\n  }\r\n\r\n  @media print {\r\n    display: none;\r\n  }\r\n}\r\n\r\n::ng-deep .mat-drawer-inner-container {\r\n  overflow: hidden !important;\r\n}\r\n::ng-deep mat-expansion-panel.mat-expansion-panel {\r\n  margin-bottom: 12px !important;\r\n}\r\n\r\n.mat-drawer-container {\r\n  background-color: #fafafa;\r\n}\r\n\r\n.img {\r\n  @include mix.m(top) {\r\n    height: 720px;\r\n    opacity: 0.5;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    width: auto;\r\n    z-index: -1;\r\n  }\r\n}\r\n\r\n.sidenav .mat-toolbar {\r\n  background: inherit;\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n.mat-toolbar {\r\n  @media print {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.mat-sidenav-content {\r\n  @media print {\r\n    margin: 0 !important;\r\n  }\r\n}\r\n\r\n.mat-toolbar.mat-primary {\r\n  justify-content: flex-end;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.example-container {\r\n  background: #eee;\r\n  bottom: 0;\r\n  left: 0;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n}\r\n\r\n.app-title,\r\n.user {\r\n  align-items: center;\r\n  display: flex;\r\n  font-size: 20px;\r\n\r\n  @include mix.respond(460px) {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.scrollTagOffset {\r\n  position: absolute;\r\n  top: -20px;\r\n}\r\n\r\n.user {\r\n  margin-left: 0;\r\n  max-width: none;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-shrink: 0;\r\n  min-width: 0;\r\n\r\n  @include mix.respond(460px) {\r\n    margin-left: 20px;\r\n    max-width: none;\r\n    gap: 0.375rem;\r\n  }\r\n\r\n  // At 200% zoom on 1280px viewport (effectively 640px)\r\n  @include mix.respond(640px) {\r\n    max-width: none;\r\n    gap: 0.25rem;\r\n  }\r\n\r\n  // At 300% zoom or smaller screens\r\n  @include mix.respond(426px) {\r\n    max-width: none;\r\n    gap: 0.25rem;\r\n  }\r\n}\r\n\r\n.user-icon {\r\n  margin-right: 5px;\r\n  flex-shrink: 0;\r\n  font-size: 20px;\r\n  width: 20px;\r\n  height: 20px;\r\n\r\n  @include mix.respond(640px) {\r\n    font-size: 18px;\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n\r\n  @include mix.respond(426px) {\r\n    font-size: 16px;\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n}\r\n\r\n.user-name {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  min-width: 0;\r\n\r\n  // Show full text on larger screens\r\n  @media (min-width: 641px) {\r\n    overflow: visible;\r\n    text-overflow: clip;\r\n  }\r\n}\r\n\r\n.fill-remaining-space {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.mat-mdc-list-item {\r\n  font-size: 15px;\r\n  margin-left: 8px;\r\n}\r\n\r\n.mdc-list {\r\n  padding: 0;\r\n  padding-top: 4px;\r\n}\r\n\r\n.wrapText {\r\n  white-space: normal;\r\n}\r\n\r\n.mat-mdc-list-base[dense] .mat-mdc-list-item {\r\n  font-size: 14px;\r\n  height: 40px;\r\n}\r\n\r\n.contain-list {\r\n  // Smaller screen heights can see all nav items\r\n  margin-bottom: 200px;\r\n}\r\n\r\n.main-content {\r\n  margin: 0 auto;\r\n  max-width: 1920px;\r\n  padding: 16px 35px;\r\n\r\n  // Desktop minimum width; below this the layout reflows for mobile/tablet\r\n  // and the sidenav switches to overlay (drawer) mode so full viewport is used.\r\n  @media (min-width: 768px) {\r\n    min-width: 550px;\r\n  }\r\n\r\n  @include mix.respond(1600px) {\r\n    padding: 16px 75px;\r\n  }\r\n\r\n  // Reduce padding on mobile/tablet so cards have room to breathe\r\n  @media (max-width: 767.98px) {\r\n    padding: 12px 16px;\r\n    margin: 0;\r\n  }\r\n\r\n  // WCAG 2.1 Reflow: 360px and below viewport support\r\n  @media (max-width: 360px) {\r\n    padding: 8px 15px;\r\n    margin: 0;\r\n  }\r\n\r\n  // WCAG 2.1 Reflow: 320px viewport support\r\n  @media (max-width: 320px) {\r\n    padding: 8px 10px;\r\n    margin: 0;\r\n  }\r\n\r\n  // Extra narrow support\r\n  @media (max-width: 280px) {\r\n    padding: 6px 8px;\r\n  }\r\n}\r\n\r\n.content {\r\n  min-height: 100vh;\r\n}\r\n\r\nmat-expansion-panel.mat-expansion-panel {\r\n  background-color: var.$side-nav-color-hover;\r\n  border-radius: 0px !important;\r\n\r\n  &:hover {\r\n    background-color: var.$side-nav-color-hover;\r\n  }\r\n\r\n  mat-expansion-panel-header.mat-expansion-panel-header {\r\n    background-color: var.$side-nav-color;\r\n    border-radius: 0px !important;\r\n  }\r\n}\r\n\r\nmat-nav-list.mat-mdc-nav-list {\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n\r\n  @include util.scrollbar;\r\n\r\n  .mat-mdc-list-item {\r\n    margin-bottom: 12px;\r\n    &:hover {\r\n      background-color: var.$side-nav-color-hover;\r\n    }\r\n    &:first-of-type {\r\n      margin-top: 12px;\r\n    }\r\n  }\r\n}\r\n\r\n.nav {\r\n  @include mix.m(top) {\r\n    background-color: #fff;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\r\n    box-shadow: 0 0 16px -6px rgba(0, 0, 0, 0.1);\r\n    height: 75px;\r\n    margin-bottom: 25px;\r\n    padding-bottom: 12px;\r\n    padding-top: 12px;\r\n    position: relative;\r\n    z-index: 10;\r\n  }\r\n\r\n  @include mix.e(notifications) {\r\n    margin-left: 25px;\r\n  }\r\n}\r\n\r\n.route {\r\n  @include mix.m(active) {\r\n    border-left: 4px solid map.get(theme.$ascend-primary, 500);\r\n  }\r\n\r\n  @include mix.e(indicator) {\r\n    @include mix.m(active) {\r\n      border-left: 4px solid map.get(theme.$ascend-primary, 500);\r\n      height: 40px;\r\n      padding-right: 10px;\r\n      position: absolute;\r\n      left: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n.user {\r\n  @include mix.e(options) {\r\n    display: flex;\r\n    align-items: center;\r\n    max-width: none;\r\n    min-width: 0;\r\n\r\n    // At 200% zoom on 1280px viewport\r\n    @include mix.respond(640px) {\r\n      max-width: 200px;\r\n      overflow: hidden;\r\n\r\n      .user {\r\n        max-width: 160px;\r\n\r\n        .user-name {\r\n          max-width: 120px;\r\n          overflow: hidden;\r\n          text-overflow: ellipsis;\r\n          white-space: nowrap;\r\n        }\r\n      }\r\n    }\r\n\r\n    // At 300% zoom or smaller screens\r\n    @include mix.respond(426px) {\r\n      max-width: 150px;\r\n\r\n      .user {\r\n        max-width: 120px;\r\n        gap: 0.125rem;\r\n\r\n        .user-name {\r\n          max-width: 80px;\r\n          font-size: 14px;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Hide desktop variant at narrow widths\r\n    &.user__options--desktop {\r\n      @media (max-width: 640px) {\r\n        display: none !important;\r\n      }\r\n    }\r\n\r\n    // Show mobile variant at narrow widths\r\n    &.user__options--mobile {\r\n      display: none;\r\n\r\n      @media (max-width: 640px) {\r\n        display: flex !important;\r\n        align-items: center;\r\n        justify-content: center;\r\n      }\r\n    }\r\n\r\n    // Ensure dropdown button is always visible at desktop\r\n    .mat-mdc-icon-button {\r\n      flex-shrink: 0;\r\n      margin-left: 0.25rem;\r\n      margin-right: 0.5rem;\r\n      width: 40px;\r\n      height: 40px;\r\n      padding: 8px;\r\n\r\n      @include mix.respond(640px) {\r\n        width: 36px;\r\n        height: 36px;\r\n        padding: 6px;\r\n        margin-left: 0.125rem;\r\n        margin-right: 0.375rem;\r\n      }\r\n\r\n      @include mix.respond(426px) {\r\n        width: 32px;\r\n        height: 32px;\r\n        padding: 4px;\r\n        margin-left: 0;\r\n        margin-right: 0.25rem;\r\n      }\r\n    }\r\n\r\n    @include mix.m(sidenav) {\r\n      display: none;\r\n\r\n      @include mix.respond(460px) {\r\n        bottom: 0;\r\n        display: inline;\r\n        left: 0;\r\n        position: absolute;\r\n        right: 0;\r\n        max-width: none;\r\n        overflow: visible;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Hide desktop selectors in the top toolbar at mobile widths; users get to\r\n// them through the mobile-user-menu instead. Matches DMS's 640px handoff so\r\n// the toolbar transitions cleanly at the same breakpoint as the user menu.\r\n.nav__left {\r\n  @media (max-width: 640px) {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n// Mobile user button (account_circle) — sized for 44px touch target per WCAG.\r\n.mobile-user-button {\r\n  width: 44px !important;\r\n  height: 44px !important;\r\n  min-width: 44px;\r\n  min-height: 44px;\r\n\r\n  .mat-icon {\r\n    font-size: 24px;\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 2px solid #1976d2;\r\n    outline-offset: 2px;\r\n  }\r\n}\r\n\r\n// Mobile user menu (panel with user info, embedded selectors, settings, sign out)\r\n.mobile-user-menu {\r\n  .mat-mdc-menu-panel {\r\n    min-width: 320px;\r\n    max-width: 400px;\r\n\r\n    @media (max-width: 640px) {\r\n      min-width: 300px;\r\n      max-width: min(400px, calc(100vw - 40px));\r\n    }\r\n\r\n    @media (max-width: 340px) {\r\n      min-width: calc(100vw - 20px);\r\n      max-width: calc(100vw - 20px);\r\n      left: 10px !important;\r\n      right: 10px !important;\r\n    }\r\n\r\n    @media (max-width: 320px) {\r\n      min-width: calc(100vw - 16px);\r\n      max-width: calc(100vw - 16px);\r\n      left: 8px !important;\r\n      right: 8px !important;\r\n    }\r\n  }\r\n\r\n  .mobile-user-info {\r\n    display: flex !important;\r\n    align-items: center;\r\n    padding: 16px !important;\r\n    cursor: default !important;\r\n\r\n    &:hover {\r\n      background-color: transparent !important;\r\n    }\r\n\r\n    .mobile-user-avatar {\r\n      font-size: 40px;\r\n      width: 40px;\r\n      height: 40px;\r\n      margin-right: 12px;\r\n      color: #1976d2;\r\n    }\r\n\r\n    .mobile-user-details {\r\n      flex: 1;\r\n      min-width: 0;\r\n\r\n      .mobile-user-name {\r\n        font-weight: 600;\r\n        font-size: 16px;\r\n        margin-bottom: 4px;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        color: #333;\r\n      }\r\n\r\n      .mobile-user-role {\r\n        font-size: 14px;\r\n        color: #666;\r\n      }\r\n    }\r\n  }\r\n\r\n  .mat-mdc-menu-item {\r\n    min-height: 48px;\r\n    padding: 12px 16px;\r\n\r\n    .mat-icon {\r\n      margin-right: 12px;\r\n      color: #1976d2;\r\n      font-size: 20px;\r\n      width: 20px;\r\n      height: 20px;\r\n    }\r\n\r\n    span {\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n    }\r\n\r\n    &:hover {\r\n      background-color: rgba(25, 118, 210, 0.04);\r\n    }\r\n\r\n    &:focus {\r\n      background-color: rgba(25, 118, 210, 0.08);\r\n      outline: none;\r\n    }\r\n  }\r\n\r\n  .mat-divider {\r\n    margin: 8px 0;\r\n  }\r\n\r\n  // Embedded selector items (School Year / District) inside the menu\r\n  .mobile-selectors {\r\n    padding: 8px 0;\r\n\r\n    .mobile-selector-item {\r\n      display: flex !important;\r\n      align-items: flex-start !important;\r\n      padding: 12px 16px !important;\r\n      cursor: default !important;\r\n      min-height: auto !important;\r\n      background: transparent !important;\r\n      width: 100% !important;\r\n      text-align: left !important;\r\n      border: none !important;\r\n\r\n      &:hover {\r\n        background-color: rgba(25, 118, 210, 0.04) !important;\r\n      }\r\n\r\n      &:focus {\r\n        background-color: rgba(25, 118, 210, 0.08) !important;\r\n        outline: 2px solid #1976d2;\r\n        outline-offset: -2px;\r\n      }\r\n\r\n      .selector-icon {\r\n        margin-right: 12px;\r\n        margin-top: 12px;\r\n        color: #1976d2;\r\n        font-size: 20px;\r\n        width: 20px;\r\n        height: 20px;\r\n        flex-shrink: 0;\r\n      }\r\n\r\n      .selector-content {\r\n        flex: 1;\r\n        min-width: 0;\r\n        width: 100%;\r\n\r\n        .selector-label {\r\n          font-size: 12px;\r\n          color: #333333;\r\n          margin-bottom: 4px;\r\n          font-weight: 500;\r\n        }\r\n\r\n        .mobile-form-field {\r\n          width: 100%;\r\n          margin: 0;\r\n\r\n          .mat-mdc-form-field-wrapper {\r\n            padding-bottom: 0;\r\n          }\r\n\r\n          .mat-mdc-form-field-flex {\r\n            min-height: 44px;\r\n            background: #f5f5f5;\r\n            border-radius: 4px;\r\n          }\r\n\r\n          .mat-mdc-select {\r\n            font-size: 14px;\r\n            width: 100%;\r\n\r\n            .mat-mdc-select-trigger {\r\n              min-height: 44px;\r\n              padding: 8px 12px;\r\n              display: flex;\r\n              align-items: center;\r\n            }\r\n\r\n            .mat-mdc-select-value {\r\n              color: #333;\r\n              font-weight: 500;\r\n            }\r\n\r\n            .mat-mdc-select-arrow {\r\n              color: #1976d2;\r\n            }\r\n\r\n            &:focus {\r\n              outline: 2px solid #1976d2;\r\n              outline-offset: 2px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.version {\r\n  bottom: 1vh;\r\n  left: 1vh;\r\n  position: absolute;\r\n}\r\n\r\n.help {\r\n  bottom: 1vh;\r\n  position: absolute;\r\n  width: inherit;\r\n  background-color: #f6f6f6;\r\n}\r\n.help-list {\r\n  right: 2vh;\r\n  position: relative;\r\n  width: inherit;\r\n}\r\n\r\n.bottom-buttons {\r\n  bottom: 4vh;\r\n  left: 0;\r\n  position: absolute;\r\n  right: 0;\r\n\r\n  button[mat-raised-button] {\r\n    background-color: darken(var.$side-nav-color, 7%);\r\n    border-radius: 0;\r\n    box-shadow: none;\r\n    padding: 7px;\r\n    width: 100%;\r\n\r\n    &:not(:last-of-type) {\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n.sticky-note {\r\n  @include mix.e(icon) {\r\n    color: map.get(theme.$i3-colors, \"yellowBackground\");\r\n  }\r\n}\r\n\r\n@media print {\r\n  .bg-img {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.hamburger-icon {\r\n  height: 20px;\r\n  width: auto;\r\n\r\n  .arrow {\r\n    transition: 0.3s ease;\r\n    transform-origin: center;\r\n  }\r\n\r\n  @include mix.m(closed) {\r\n    .arrow {\r\n      transform: rotate(180deg) translate(40px, 2px);\r\n    }\r\n  }\r\n}\r\n\r\n.administrativeUnit-selector {\r\n  margin-top: 20px;\r\n  margin-right: 20px;\r\n  min-width: 300px;\r\n\r\n  // WCAG 2.1 Reflow: progressively shrink at mobile widths\r\n  @media (max-width: 360px) {\r\n    min-width: auto;\r\n    margin-right: 10px;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    max-width: 280px;\r\n  }\r\n\r\n  @media (max-width: 320px) {\r\n    min-width: auto;\r\n    margin-right: 8px;\r\n    margin-top: 8px;\r\n    width: 100%;\r\n    max-width: 260px;\r\n  }\r\n}\r\n\r\n.schoolyear-selector {\r\n  margin-top: 20px;\r\n  margin-right: 20px;\r\n  min-width: 200px;\r\n\r\n  // WCAG 2.1 Reflow: progressively shrink at mobile widths\r\n  @media (max-width: 360px) {\r\n    min-width: auto;\r\n    margin-right: 10px;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    max-width: 140px;\r\n  }\r\n\r\n  @media (max-width: 320px) {\r\n    min-width: auto;\r\n    margin-right: 8px;\r\n    margin-top: 8px;\r\n    width: 100%;\r\n    max-width: 120px;\r\n  }\r\n}\r\n\r\n.nav {\r\n  @include mix.e(container) {\r\n    align-items: center;\r\n    display: flex;\r\n    flex: 1;\r\n    justify-content: flex-end;\r\n    min-width: 0; // Allow flexbox items to shrink\r\n  }\r\n\r\n  @include mix.e(left) {\r\n    div {\r\n      display: flex;\r\n      min-width: 0; // Allow flexbox items to shrink\r\n    }\r\n  }\r\n\r\n  @include mix.e(right) {\r\n    min-width: 0; // Allow flexbox items to shrink\r\n    flex-shrink: 1;\r\n  }\r\n\r\n  @include mix.e(input) {\r\n    margin-right: 1.25em;\r\n    margin-top: 1.25em;\r\n    min-width: 0; // Allow flexbox items to shrink\r\n\r\n    @include mix.m(year) {\r\n      min-width: 150px;\r\n\r\n      @include mix.respond(640px) {\r\n        min-width: 120px;\r\n      }\r\n\r\n      // WCAG 2.1 Reflow: progressively shrink at narrow widths\r\n      @media (max-width: 360px) {\r\n        min-width: auto;\r\n        width: 100%;\r\n        max-width: 140px;\r\n        margin-right: 0.5em;\r\n        margin-top: 0.5em;\r\n      }\r\n\r\n      @media (max-width: 320px) {\r\n        min-width: auto;\r\n        width: 100%;\r\n        max-width: 120px;\r\n        margin-right: 0.25em;\r\n        margin-top: 0.25em;\r\n      }\r\n    }\r\n\r\n    @include mix.m(administrativeUnit) {\r\n      width: 360px;\r\n\r\n      @include mix.respond(1150px) {\r\n        width: unset;\r\n        min-width: 200px;\r\n      }\r\n\r\n      @include mix.respond(640px) {\r\n        min-width: 150px;\r\n      }\r\n\r\n      // WCAG 2.1 Reflow: progressively shrink at narrow widths\r\n      @media (max-width: 360px) {\r\n        min-width: auto;\r\n        width: 100%;\r\n        max-width: 200px;\r\n        margin-right: 0.5em;\r\n        margin-top: 0.5em;\r\n      }\r\n\r\n      @media (max-width: 320px) {\r\n        min-width: auto;\r\n        width: 100%;\r\n        max-width: 170px;\r\n        margin-right: 0.25em;\r\n        margin-top: 0.25em;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.mat-accordion:focus-within .mat-expansion-panel-header:focus-within {\r\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n  background-color: #FFFFFF;\r\n  outline: 2px solid #1976d2;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.mat-expansion-panel-header-title {\r\n  outline: none;\r\n}\r\n\r\n.mat-mdc-list-item:focus {\r\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n  background-color: #FFFFFF;\r\n  outline: 2px solid #1976d2;\r\n  outline-offset: 2px;\r\n}\r\n\r\n::ng-deep #schoolYearSelector .mdc-text-field,\r\n::ng-deep #districtSelector .mdc-text-field,\r\n::ng-deep #search .mdc-text-field {\r\n  background-color: transparent !important;\r\n}\r\n\r\n// .mat-form-field-appearance-fill .mat-mdc-form-field-flex {\r\n//   border-radius: 4px 4px 0 0 !important;\r\n//   padding: .75em .75em 0 .75em !important;\r\n// }\r\n\r\n// .mat-form-field-appearance-fill .mat-mdc-form-field-inflix {\r\n//   padding: 0 !important;\r\n// }\r\n","@use \"sass:map\";\r\n\r\n@use './mixins' as mix;\r\n@use './variables' as var;\r\n@use './src/styles/theme/theme-variables' as theme;\r\n\r\n$displays: flex, block, inline-block, grid, inline, inline-flex, none;\r\n\r\n@each $display in $displays {\r\n  .display {\r\n    @include mix.c($display) {\r\n      display: $display !important;\r\n    }\r\n  }\r\n}\r\n\r\n.direction {\r\n  @include mix.c(column) {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n.align {\r\n  @include mix.c(items) {\r\n    @include mix.c(start) {\r\n      align-items: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      align-items: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      align-items: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      align-items: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      align-items: baseline !important;\r\n    }\r\n  }\r\n  @include mix.c(content) {\r\n    @include mix.c(start) {\r\n      align-content: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      align-content: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      align-content: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      align-content: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      align-content: baseline !important;\r\n    }\r\n    @include mix.c(between) {\r\n      align-content: space-between !important;\r\n    }\r\n    @include mix.c(around) {\r\n      align-content: space-around !important;\r\n    }\r\n  }\r\n  @include mix.c(self) {\r\n    @include mix.c(start) {\r\n      align-self: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      align-self: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      align-self: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      align-self: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      align-self: baseline !important;\r\n    }\r\n  }\r\n}\r\n\r\n.justify {\r\n  @include mix.c(items) {\r\n    @include mix.c(start) {\r\n      justify-items: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      justify-items: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      justify-items: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      justify-items: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      justify-items: baseline !important;\r\n    }\r\n  }\r\n  @include mix.c(content) {\r\n    @include mix.c(start) {\r\n      justify-content: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      justify-content: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      justify-content: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      justify-content: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      justify-content: baseline !important;\r\n    }\r\n    @include mix.c(between) {\r\n      justify-content: space-between !important;\r\n    }\r\n    @include mix.c(around) {\r\n      justify-content: space-around !important;\r\n    }\r\n  }\r\n  @include mix.c(self) {\r\n    @include mix.c(start) {\r\n      justify-content: flex-start !important;\r\n    }\r\n    @include mix.c(center) {\r\n      justify-content: center !important;\r\n    }\r\n    @include mix.c(end) {\r\n      justify-content: flex-end !important;\r\n    }\r\n    @include mix.c(stretch) {\r\n      justify-content: stretch !important;\r\n    }\r\n    @include mix.c(baseline) {\r\n      justify-content: baseline !important;\r\n    }\r\n  }\r\n}\r\n\r\n.flex {\r\n  @include mix.c(wrap) {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  @include mix.c(1) {\r\n    flex: 1 !important;\r\n  }\r\n}\r\n\r\n$positions: \"relative\", \"absolute\", \"fixed\", \"static\";\r\n@each $pos in $positions {\r\n  .position {\r\n    @include mix.c($pos) {\r\n      position: $pos !important;\r\n    }\r\n  }\r\n}\r\n\r\n.background {\r\n  @include mix.c(color) {\r\n    @include mix.m(\"white\") {\r\n      background-color: white !important;\r\n    }\r\n\r\n    @include mix.m(primary) {\r\n      background-color: map.get(theme.$ascend-primary, 500) !important;\r\n    }\r\n\r\n    @include mix.m(secondary) {\r\n      background-color: map.get(theme.$ascend-primary, 500) !important;\r\n    }\r\n\r\n    @include mix.m(success) {\r\n      $color: #becdae;\r\n      background-color: $color !important;\r\n    }\r\n\r\n    @include mix.m(muted) {\r\n      background-color: #e6e6e6 !important;\r\n    }\r\n\r\n    @include mix.m(danger) {\r\n      background-color: map.get(theme.$ascend-error, 500) !important;\r\n    }\r\n  }\r\n}\r\n\r\n$widths: (\r\n  25: 25%,\r\n  50: 50%,\r\n  75: 75%,\r\n  100: 100%,\r\n  fit: fit-content,\r\n);\r\n@each $width, $percent in $widths {\r\n  .w {\r\n    @include mix.c($width) {\r\n      width: $percent !important;\r\n    }\r\n  }\r\n}\r\n\r\n.card {\r\n  @include mix.c(spacing) {\r\n    @include mix.c(top) {\r\n      margin-top: map.get(theme.$misc-variables, \"card-spacing\") !important;\r\n    }\r\n\r\n    @include mix.c(bottom) {\r\n      margin-bottom: map.get(theme.$misc-variables, \"card-spacing\") !important;\r\n    }\r\n  }\r\n}\r\n\r\n.line-height {\r\n  @include mix.c(16) {\r\n    line-height: 1.6;\r\n  }\r\n}\r\n\r\n// Text\r\n.text {\r\n  $aligns: (left, center, right);\r\n  @each $align in $aligns {\r\n    @include mix.c($align) {\r\n      text-align: $align !important;\r\n    }\r\n  }\r\n\r\n  $sizes: (\r\n    xs: 10px,\r\n    sm: 14px,\r\n    md: 15px,\r\n    nrm: 16px,\r\n    lg: 20px,\r\n  );\r\n  @each $text, $size in $sizes {\r\n    @include mix.c($text) {\r\n      font-size: $size !important;\r\n    }\r\n  }\r\n\r\n  $styles: (normal, italic);\r\n  @each $style in $styles {\r\n    @include mix.c($style) {\r\n      font-style: $style !important;\r\n    }\r\n  }\r\n\r\n  $weights: (\r\n    normal: 400,\r\n    semibold: 600,\r\n  );\r\n  @each $text, $weight in $weights {\r\n    @include mix.c($text) {\r\n      font-weight: $weight !important;\r\n    }\r\n  }\r\n\r\n  $transforms: (\r\n    \"cap\": capitalize,\r\n    \"upper\": uppercase,\r\n    \"lower\": lowercase,\r\n  );\r\n  @each $name, $value in $transforms {\r\n    @include mix.c($name) {\r\n      text-transform: $value !important;\r\n    }\r\n  }\r\n\r\n  @include mix.c(\"white\") {\r\n    color: #fff !important;\r\n  }\r\n  @include mix.c(\"black\") {\r\n    color: rgba(0, 0, 0, 0.87) !important;\r\n  }\r\n  @include mix.c(link) {\r\n    color: #0000ff;\r\n    cursor: pointer;\r\n  }\r\n  @include mix.c(primary) {\r\n    color: map.get(theme.$ascend-primary, 500) !important;\r\n  }\r\n  @include mix.c(success) {\r\n    color: map.get(theme.$ascend-success, 500) !important;\r\n  }\r\n  @include mix.c(danger) {\r\n    color: map.get(theme.$ascend-error, 500) !important;\r\n  }\r\n  @include mix.c(muted) {\r\n    color: rgba(0, 0, 0, 0.54);\r\n  }\r\n\r\n  @include mix.c(underline) {\r\n    text-decoration: underline !important;\r\n\r\n    @include mix.c(none) {\r\n      text-decoration: none !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Border\r\n.border {\r\n  @include mix.c(0) {\r\n    border-width: 0 !important;\r\n  }\r\n\r\n  @include mix.c(none) {\r\n    border: 0px solid transparent !important;\r\n  }\r\n}\r\n\r\n// Cursor\r\n.cursor {\r\n  @include mix.c(pointer) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Page settings\r\n.page {\r\n  @include mix.c(bottom) {\r\n    @include mix.c(leeway) {\r\n      margin-bottom: 200px;\r\n    }\r\n  }\r\n}\r\n\r\n.transition {\r\n  @include mix.c(default) {\r\n    transition: 0.2s ease;\r\n  }\r\n}\r\n\r\n$overflows: (hidden, visible, auto);\r\n.overflow {\r\n  @each $overflow in $overflows {\r\n    @include mix.c($overflow) {\r\n      overflow: $overflow !important;\r\n    }\r\n  }\r\n}\r\n\r\n.box-shadow {\r\n  @include mix.m(normal) {\r\n    box-shadow: 0 0 41px -19px rgba(map.get(theme.$ascend-primary, 500), 0.3) !important;\r\n  }\r\n}\r\n\r\n// Error\r\n.mat-mdc-form-field-error {\r\n  font-size: 12px;\r\n}\r\n\r\n@mixin scrollbar {\r\n  &::-webkit-scrollbar {\r\n    width: 10px;\r\n    height: 10px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: darken(#fff, 14%);\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: darken(#fff, 38%);\r\n  }\r\n}","// Brand Colors\r\n$brand-blue-light: #a8c0e4;\r\n$brand-maroon: #a12041;\r\n$brand-maroon-swap: #1a8435;\r\n$brand-gray-darker: #58595b;\r\n$brand-gray-dark: #808285;\r\n$brand-gray-light: #a7a9ac;\r\n$brand-gray-lightest: #d1d3d4;\r\n\r\n// Spacing\r\n$space-sm: 8px;\r\n$space-md: 16px;\r\n$space-lg: 24px;\r\n\r\n// Side Nav\r\n$side-nav-width: 210px;\r\n$side-nav-color: #f6f6f6;\r\n$side-nav-color-hover: rgba(0, 0, 0, 0.04);\r\n\r\n// Media Res\r\n$tablet: 768px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
